import React from 'react'
import { useMessage } from '../../hooks/message'
import { usePutRequest } from '../../hooks/request'
import { PAYMENT_DETAIL } from '../../urls'
import PaymentForm from './PaymentForm'

export default function PaymentUpdate({ onCancel, item }) {
    const [showMessage] = useMessage()

    const client = usePutRequest({ url: PAYMENT_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data, action) {
        const { success, error } = await client.request({ data })

        if (success) {
            onCancel()
            action.resetForm()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered is-capitalized">
                <b>Ўзгартириш</b>
            </h1>
            <PaymentForm loading={client.loading} initialValues={item} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
